import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import DatosSolicitante from "../../components/funcionarios/DatosSolicitante";
import BotonVolver from "../../components/funcionarios/BotonVolver";
import { Container, Row, Col } from "react-bootstrap";
import HistorialAtenciones from "../../components/funcionarios/HistorialAtenciones";
import {
  editarSolicitante,
  getFichaSolicitante,
} from "../../services/apis_funcionarios";

function FichaSolicitante({ isAtendiendo = false, fallback, stateToReturn = null }) {
  const { idS: idFromParams } = useParams();
  const location = useLocation();
  const navigate = useNavigate(); // <-- Hook para redirigir
  const idFromState = location.state?.idActual;
  const idS = idFromState || idFromParams;

  const [solicitante, setSolicitante] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSolicitante = async () => {
    try {
      const data = await getFichaSolicitante(idS);
      // console.log("Datos del solicitante:", data);
      if (!data) {
        // Si no hay solicitante, redirigir
        if (fallback) navigate(fallback, { state: stateToReturn });
        return;
      }
      setSolicitante(data);
    } catch (error) {
      setError("Hubo un error al obtener los datos del solicitante");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSolicitante();
  }, [idS]);

  const handleEditarSolicitante = async (id, data) => {
    try {
      const updatedSolicitante = await editarSolicitante(id, data);
      setSolicitante(updatedSolicitante);
    } catch (error) {
      console.error("Error al editar solicitante:", error);
    }
  };

  if (loading)
    return (
      <div>
        {fallback && <BotonVolver fallback={fallback} stateToReturn={stateToReturn} />}
        Cargando...
      </div>
    );
  if (error)
    return (
      <div>
        {fallback && <BotonVolver fallback={fallback} stateToReturn={stateToReturn} />}
        {error}
      </div>
    );

  const atenciones = solicitante.atenciones || [];

  return (
    <Container fluid className="h-100">
      {fallback && <BotonVolver fallback={fallback} stateToReturn={stateToReturn}/>}
      <Row className="g-3" style={{ height: "100%" }}>
        <Col xs={12} lg={4} className="h-auto h-lg-100">
          <DatosSolicitante
            idS={solicitante.idS}
            nombre={solicitante.nombre}
            tipo={solicitante.tipo}
            carrera={solicitante.carrera}
            rut={solicitante.rut}
            isPasaporte={solicitante.pasaporte}
            email={solicitante.email}
            telefono={solicitante.telefono}
            flag={solicitante.flag}
            isNew={solicitante.nombre === ""}
            onSubmit={handleEditarSolicitante}
          />
        </Col>
        <Col xs={12} lg={8}>
          <HistorialAtenciones
            idS={solicitante.idS}
            atenciones={atenciones}
            onRefresh={fetchSolicitante}
            botones={isAtendiendo}
            atencionActual={solicitante.atencion_actual}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default FichaSolicitante;
